import React from "react";
import { connect } from "react-redux";
import __ from "lodash";
import { cekCookies } from "../../../../actions";
import { CONFIG } from "../../../../config";
import { Row, Col } from "react-bootstrap";
import Navbar from "../../navbar/Navbar";
import Sidebar from "../../sidebar/Sidebar";
import LoaderModal from "../../../modal/LoaderModal";

import accountManagement from "../../../../apis/accountManagement";
import filterReportDinasAgcu from "../../../../entity/FilterReportDinasAgcu";
import KelasSearch from "../../../../entity/KelasSearch";
import DropdownKelas from "../masterDropDown/DropdownKelas";
import DropdownProfilCbtDinas from "../masterDropDown/DropdownProfilCbtDinas";

import ReportTooDetail from "./ReportDinasTooDetail";
import DropdownTahunAjaran from "../masterDropDown/DropdownTahunAjaran";

class ReportDinasToo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      showAlert: false,
      resMessage: null,
      typeReport: "TOO",
      idAdmin: null,
      idProvinsi: null,
      idDinas: null,
      namaDinas: null,
      kelas: [],
      idKelas: null,
      jadwalProfilCbt: [],
      profilCbt: [],
      idProfilCbt: null,
      namaProfilCbt: null,
      dataMapel: [],
      dataRataStatistik: [],
      dataRataSekolah: [],
      dataRataPerSekolah: [],
      dataSekolahDinas: [],
      dataSatuanPend: null,
      dataJumAllSiswa: null,
      tahunAjaran: [],
      kodeTahunAjaran: null,
    };
  }

  async componentDidMount() {
    document.title = "Report Dinas TOO";
    console.time("Time componentDidMount");
    this.setState({
      isFetching: true,
    });
    await this.props.cekCookies();

    console.groupCollapsed("componentDidMount");
    console.info("CEK ACCOUNT", this.props.account);
    console.groupEnd();

    if (!__.isEmpty(this.props.account)) {
      this.fetchTa();
      this.setState({
        idAdmin: this.props.account.idAdmin,
        idProvinsi: this.props.account.idProvinsi,
        idDinas: this.props.account.idDinas,
        namaDinas: this.props.account.namaUser,
      });

      // Fetch Kelas
      const responseFetchKelas = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS, { KelasSearch, kodeJenjangSekolah: null }).catch(function (error) {
        console.error("ERROR ACCOUNT_MANAGEMENT_SEARCH_KELAS", error);
      });

      // Set State Kelas
      if (responseFetchKelas.request.readyState === 4 && responseFetchKelas.status === 200) {
        console.info("CEK KELAS", responseFetchKelas);
        if (responseFetchKelas.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
          this.setState({
            kelas: responseFetchKelas.data.data,
          });
        }
      }
    }

    window.$("#sidebar").mCustomScrollbar({
      theme: "minimal",
    });

    window.$("#sidebarCollapse").on("click", function () {
      window.$("#sidebar, #content").toggleClass("active");
      window.$(".collapse.in").toggleClass("in");
      window.$("a[aria-expanded=true]").attr("aria-expanded", "false");
    });

    this.setState({
      isFetching: false,
    });
    console.timeEnd("Time componentDidMount");
  }

  fetchTa = async () => {
    //fetch tahun ajaran dulu
    const resTa = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_LIST_TAHUN_AJARAN).catch(function (error) {});
    if (resTa) {
      if (resTa.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          tahunAjaran: resTa.data.data,
        });
      }
    }

    resTa.data.data.map((val) => {
      if (val.status === "1") {
        this.setState({ kodeTahunAjaran: val.kodeTahunAjaran });
      }
    });
  };

  handleOnChangeTahunAjaran = async (ta) => {
    this.setState({
      kodeTahunAjaran: ta.target.value,
    });
  };

  onChangeKelas = async (event) => {
    console.clear();
    console.time("Time onChangeKelas");
    this.setState({
      isFetching: true,
    });

    const fieldName = event.target.name;
    const fieldValue = event.target.value;

    console.groupCollapsed("CEK KELAS TERPILIH");
    console.info("fieldName", fieldName);
    console.info("fieldValue", fieldValue);
    console.groupEnd();

    this.setState({
      jadwalProfilCbt: [],
      idProfilCbt: null,
      namaProfilCbt: null,
      [fieldName]: fieldValue,
    });

    // Fetch Profil
    const responseFetchProfil = await accountManagement.get(CONFIG.REPORT_DINAS_AGCU_PROFIL + fieldValue).catch(function (error) {
      console.error("ERROR REPORT_DINAS_TOO_PROFIL", error);
    });
    console.info("CEK PROFIL", responseFetchProfil);

    // Set State Profil
    if (responseFetchProfil.request.readyState === 4 && responseFetchProfil.status === 200) {
      if (responseFetchProfil.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          jadwalProfilCbt: responseFetchProfil.data.data.jadwalCbt,
          isFetching: false,
        });
      }
    }
    console.timeEnd("Time onChangeKelas");
  };

  onChangeProfil(event) {
    console.clear();
    console.time("Time onChangeProfil");
    this.setState({
      isFetching: true,
    });
    const index = event.nativeEvent.target.selectedIndex;
    const label = event.nativeEvent.target[index].text;
    const fieldName = event.target.name;
    const fieldValue = event.target.value;

    console.groupCollapsed("CEK PROFIL TERPILIH");
    console.info("label", label);
    console.info("fieldName", fieldName);
    console.info("fieldValue", fieldValue);
    console.groupEnd();

    this.setState({
      [fieldName]: fieldValue,
      namaProfilCbt: label,
      isFetching: false,
    });
    console.timeEnd("Time onChangeProfil");
  }

  showReportDinasAgcu = async () => {
    console.clear();
    console.time("Time showReportDinasToo");
    this.setState({
      isFetching: true,
    });
    console.groupCollapsed("PREVIEW REPORT TOO");
    console.info(this.state.idKelas);
    console.info(this.state.idProfilCbt);

    // Fetch Report
    // const result = await accountManagement.post(CONFIG.REPORT_DINAS_AGCU_LIST, {...filterReportDinasAgcu,
    const result = await accountManagement
      .post(CONFIG.REPORT_DINAS_AGCU_NEW_LIST, { ...filterReportDinasAgcu, idKelas: this.state.idKelas, idJadwalCbt: this.state.idJadwalCbt, typeReport: "TOO" })
      .catch(function (error) {
        console.error("ERROR REPORT_DINAS_TOO_LIST", error);
      });

    if (result) {
      if (result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          // result: result.data.data,
          dataMapel: result.data.data.mapel,
          dataRataStatistik: result.data.data.rataStatistik,
          dataRataSekolah: result.data.data.rataSekolah,
          dataRataPerSekolah: result.data.data.rataPerSekolah,
          dataSekolahDinas: result.data.data.sekolahDinas,
          dataSatuanPend: result.data.data.satuanPendidikan,
          dataJumAllSiswa: result.data.data.jumAllSiswa,
          isFetching: false,
        });
      } else {
        this.setState({
          showAlert: true,
          resMessage: result.data.errorSchema.errorMessage,
          isFetching: false,
        });
      }
    }
    console.groupEnd();
    console.timeEnd("Time showReportDinasToo");
  };

  handleReport = async () => {
    console.clear();

    console.log("====================================");
    console.log("kodeTa", this.state.kodeTahunAjaran);
    console.log("idProfilCbt", this.state.idJadwalCbt);
    console.log("====================================");

    this.setState({
      kodeTahunAjaran: this.state.kodeTahunAjaran,
      idJadwalCbt: this.state.idJadwalCbt,
    });

    window.open("report_dinas_sbmptn/" + this.state.kodeTahunAjaran + "/" + this.state.idJadwalCbt, "_blank");
  };

  render() {
    console.groupCollapsed("Render Cek State/Props ReportDinasToo");
    console.info("STATE", this.state);
    console.info("PROPS", this.props);
    console.info("idKelas", this.state.idKelas);
    console.info("idJadwalCbt", this.state.idJadwalCbt);
    console.groupEnd();

    return (
      <div className="wrapper">
        <LoaderModal isFetching={this.state.isFetching} />
        <Sidebar account={this.props.account} />

        <div id="content" style={{ paddingBottom: "50px" }}>
          <Navbar />

          <Row>
            <Col sm={3}>
              <select className="form-control" value={this.state.kodeTahunAjaran} onChange={this.handleOnChangeTahunAjaran} required>
                <option value="" selected disabled>
                  ~~ Pilih Tahun Ajaran ~~
                </option>
                <DropdownTahunAjaran tahunAjaran={this.state.tahunAjaran} />
              </select>
            </Col>

            <Col sm={3}>
              <select className="form-control" name="idKelas" id="idKelas" value={this.state.idKelas === null ? "" : this.state.idKelas} onChange={this.onChangeKelas.bind(this)} required>
                <option value="" selected disabled>
                  ~~ Pilih Kelas ~~
                </option>
                <DropdownKelas kelas={this.state.kelas} />
              </select>
            </Col>

            <Col sm={4}>
              <select
                className="form-control"
                name="idJadwalCbt"
                id="idJadwalCbt"
                value={this.state.idJadwalCbt === null ? "" : this.state.idJadwalCbt}
                onChange={this.onChangeProfil.bind(this)}
                required
              >
                <option value="" selected>
                  ~~ Pilih Jadwal ~~
                </option>
                <DropdownProfilCbtDinas jadwalProfilCbt={this.state.jadwalProfilCbt} />
              </select>
            </Col>

            <Col sm={2}>
              <button className="btn btn-primary btn-sm" onClick={this.showReportDinasAgcu}>
                <i className="fa fa-search"></i> Lihat
              </button>
              &nbsp;
              <button className="btn btn-primary btn-sm" title="REPORT PDF" onClick={this.handleReport}>
                <i className="fa fa-file-pdf-o"></i>&nbsp; Report
              </button>
              {/* <button className="btn btn-primary" title="REPORT PDF" onClick={()=> window.open("reportdinastoo/" + this.state.idKelas + "/" + this.state.idProfilCbt + "/" + this.state.typeReport, "_blank")}>
                                <i className="fa fa-file-pdf-o"></i>&nbsp; Report
                            </button> */}
            </Col>
          </Row>

          <Row style={{ paddingTop: "50px" }}>
            <Col sm={12}>
              <ReportTooDetail
                namaDinas={this.state.namaDinas}
                dataMapel={this.state.dataMapel}
                sekolahDinas={this.state.dataSekolahDinas}
                rataPerSekolah={this.state.dataRataPerSekolah}
                rataSekolah={this.state.dataRataSekolah}
                satuanPendidikan={this.state.dataSatuanPend}
                jumAllSiswa={this.state.dataJumAllSiswa}
                rataStatistik={this.state.dataRataStatistik}
                namaProfilCbt={this.state.namaProfilCbt}
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    account: state.account,
  };
};

export default connect(mapStateToProps, { cekCookies })(ReportDinasToo);
